import {combineReducers} from 'redux'
import userSlice from './user'
import generalSlice from './general'

export default combineReducers({
	user: userSlice,
	general: generalSlice,
})
